import { lazy } from "react";

const StudentDashboard = lazy(() => import("./StudentDashboard"));
const StudentProfile = lazy(() => import("./StudentProfile"));
const StudentSupport = lazy(() => import("./StudentSupport"));

export { StudentDashboard, StudentProfile, StudentSupport };
